import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import {
  createListCustomer,
  getDeliveryMethodList,
  getLanguageList,
  getListCountry,
  getListSalesmenList,
  getMaturityDatesList,
  getPaymentMethodList,
  getProductPriceClassList,
  getTimeZoneList,
  updateListCustomer,
  getDocumentSetList,
  getTaxList,
} from "../../services/MoloniServices";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ConfigDB from "../../config";

const AddSupplier = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const { uuid } = useParams();
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [supplierData, setSupplierData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    code: "",
    copy_quantity_id: "",
  });

  let errorsObj = {
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [currentStep, setCurrentStep] = useState("step1");
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [countryList, setCountryList] = useState([]);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });
  const [editIndex, setEditIndex] = useState(null);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  const resetAltForm = () => {
    setAltForm({
      description: "",
      code: "",
      address: "",
      zip_code: "",
      city: "",
      country: "",
      email: "",
      phone: "",
      fax: "",
      contact_person: "",
    });
    setEditIndex(null);
  };

  const editAlternateAddress = (index) => {
    setAltForm(supplierData.alternate_address[index]);
    setEditIndex(index);
  };

  const deleteAlternateAddress = (index) => {
    const updated = supplierData?.alternate_address?.filter(
      (_, i) => i !== index,
    );

    setSupplierData({
      ...supplierData,
      alternate_address: updated,
    });
  };

  const saveAlternateAddress = () => {
    if (
      !altForm.description ||
      !altForm.code ||
      !altForm.address ||
      !altForm.zip_code ||
      !altForm.city ||
      !altForm.country
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    let updatedList = [...supplierData.alternate_address];

    if (editIndex !== null) {
      updatedList[editIndex] = altForm;
    } else {
      updatedList.push(altForm);
    }

    setAltForm({
      ...supplierData,
      alternate_address: updatedList,
    });

    resetAltForm();
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (state) {
      setSupplierData({
        id: state?.id,
        vat: state?.vat,
        number: state?.number,
        name: state?.name,
        language_id: state?.language_id,
        notes: state?.notes,
        country_id: state?.country_id,
        address: state?.address,
        zip_code: state?.zip_code,
        city: state?.city,
        email: state?.email,
        website: state?.website,
        phone: state?.phone,
        contact_name: state?.contact_name,
        contact_email: state?.contact_email,
        contact_phone: state?.contact_phone,
        discount: state?.discount,
        credit_limit: state?.credit_limit,
        payment_method_id: state?.payment_method_id,
        delivery_method_id: state?.delivery_method_id,
        maturity_date_id: state?.maturity_date_id,
        field_notes: state?.field_notes,
        moloni_id: state?.moloni_id,
        fax: state?.fax,
        salesman_id: state?.salesman_id,
        price_class_id: state?.price_class_id,
        payment_day: state?.payment_day,
        document_type_id: state?.document_type_id,
      });
    }
  }, [state]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTimeZoneList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].code,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductPriceClassList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setPriceClassList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };

    if (!supplierData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.language_id) {
      setActiveCustomerTab("3");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.base_commission) {
      toast.error("Base Commission is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!supplierData.phone) {
      toast.error("Phone is required.");
      setActiveCustomerTab("2");
      setIsModifyButtonLoad(false);
      return;
    }

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      vat: supplierData?.vat,
      number: supplierData?.number,
      name: supplierData?.name,
      language_id: supplierData?.language_id,
      notes: supplierData?.notes,
      country_id: supplierData?.country_id,
      address: supplierData?.address,
      zip_code: supplierData?.zip_code,
      city: supplierData?.city,
      email: supplierData?.email,
      website: supplierData?.website,
      phone: supplierData?.phone,
      fax: supplierData?.fax,
      contact_name: supplierData?.contact_name,
      contact_email: supplierData?.contact_email,
      contact_phone: supplierData?.contact_phone,
      discount: supplierData?.discount,
      credit_limit: supplierData?.credit_limit,
      payment_method_id: supplierData?.payment_method_id,
      delivery_method_id: supplierData?.delivery_method_id,
      maturity_date_id: supplierData?.maturity_date_id,
      field_notes: supplierData?.field_notes,
      price_class_id: supplierData?.price_class_id,
      payment_day: supplierData?.payment_day,
      document_type_id: 0,
      qty_copies_document: supplierData?.qty_copies_document,
      base_commission: supplierData?.base_commission,
    };

    let updateData = {
      company_id: "269134",
      id: supplierData?.id,
      vat: supplierData?.vat,
      number: supplierData?.number,
      name: supplierData?.name,
      language_id: supplierData?.language_id,
      notes: supplierData?.notes,
      country_id: supplierData?.country_id,
      address: supplierData?.address,
      zip_code: supplierData?.zip_code,
      city: supplierData?.city,
      email: supplierData?.email,
      website: supplierData?.website,
      phone: supplierData?.phone,
      fax: supplierData?.fax,
      contact_name: supplierData?.contact_name,
      contact_email: supplierData?.contact_email,
      contact_phone: supplierData?.contact_phone,
      discount: supplierData?.discount,
      credit_limit: supplierData?.credit_limit,
      payment_method_id: supplierData?.payment_method_id,
      delivery_method_id: supplierData?.delivery_method_id,
      maturity_date_id: supplierData?.maturity_date_id,
      field_notes: supplierData?.field_notes,
      price_class_id: supplierData?.price_class_id,
      payment_day: supplierData?.payment_day,
      document_type_id: 0,
      customer_id: supplierData?.moloni_id,
      qty_copies_document: supplierData?.qty_copies_document,
      base_commission: supplierData?.base_commission,
    };

    if (supplierData?.id) {
      updateListCustomer(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/suppliers");

          setIsModifyButtonLoad(false);
          setSupplierData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createListCustomer(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/suppliers");
          setIsModifyButtonLoad(false);

          setSupplierData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center"></div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="card card-primary">
              <div className="card-body">
                <div className="row justify-content-start">
                  <div className="col-md-12">
                    <h5 className="page-title">Supplier</h5>
                    <h5 className="page-title">
                      {uuid
                        ? `In this section you can change the supplier ${supplierData?.name}`
                        : "In this section you can insert a new supplier"}
                    </h5>

                    <Form method={`post`} onSubmit={handleSubmitForm}>
                      <div className="row">
                        <div className="mb-3">
                          {/* Tabs */}
                          <ul className="custom-tabs">
                            <li
                              className={
                                activeCustomerTab === "1"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("1")}
                            >
                              {t("main")}
                            </li>

                            <li
                              className={
                                activeCustomerTab === "2"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("2")}
                            >
                              {t("contact")}
                            </li>

                            <li
                              className={
                                activeCustomerTab === "3"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("3")}
                            >
                              {t("billingCondition")}
                            </li>
                          </ul>

                          <div className="tab-content-area">
                            {activeCustomerTab === "1" && (
                              <div className="row">
                                <div class="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>
                                <p>General Information</p>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("vat")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.vat}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            vat: e.target.value,
                                          });
                                        }}
                                        name={`vat`}
                                        maxLength={50}
                                        placeholder="Vat"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("supplierCode")}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.number}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            number: e.target.value,
                                          });
                                        }}
                                        name={`number`}
                                        maxLength={50}
                                        placeholder="Supplier Code"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("Name")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.name}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            name: e.target.value,
                                          });
                                        }}
                                        name={`name`}
                                        maxLength={50}
                                        placeholder="Name"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("copyQuantity")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={
                                            ConfigDB?.data?.copyQuantityList
                                          }
                                          value={ConfigDB?.data?.copyQuantityList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.qty_copies_document,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              qty_copies_document:
                                                selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Copy Quantity"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>{" "}
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("base_commission")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.base_commission}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            base_commission: e.target.value,
                                          });
                                        }}
                                        name={`base_commission`}
                                        maxLength={50}
                                        placeholder="Base Commission"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>{" "}
                                <div className="col-md-4" />
                                <div class="alert alert-primary" role="alert">
                                  Fill with default data
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <textarea
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.address}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            address: e.target.value,
                                          });
                                        }}
                                        name={`address`}
                                        maxLength={50}
                                        placeholder="Address"
                                        rows={3}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("city")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.city}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            city: e.target.value,
                                          });
                                        }}
                                        name={`city`}
                                        maxLength={50}
                                        placeholder="City"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("zip_code")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.zip_code}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            zip_code: e.target.value,
                                          });
                                        }}
                                        name={`zip_code`}
                                        maxLength={50}
                                        placeholder="Zip code"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("country")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.country_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              country_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("email")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.email}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            email: e.target.value,
                                          });
                                        }}
                                        name={`email`}
                                        maxLength={50}
                                        placeholder="Contact email"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4" />
                              </div>
                            )}

                            {activeCustomerTab === "2" && (
                              <div className="row">
                                <div class="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>

                                <p>Contacts</p>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("phone")}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={supplierData.phone}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            phone: e.target.value,
                                          });
                                        }}
                                        name={`phone`}
                                        placeholder="Phone"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("fax")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={supplierData.fax}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            fax: e.target.value,
                                          });
                                        }}
                                        name={`fax`}
                                        placeholder="Fax"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("website")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.website}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            website: e.target.value,
                                          });
                                        }}
                                        name={`website`}
                                        placeholder="website"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("contactPerson")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.contact_person}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            contact_person: e.target.value,
                                          });
                                        }}
                                        name={`contact_person`}
                                        placeholder="Contact Person"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("contactEmail")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.contact_email}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            contact_email: e.target.value,
                                          });
                                        }}
                                        name={`contact_email`}
                                        placeholder="Contact Email"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("telephoneContact")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.telephone_contact}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            telephone_contact: e.target.value,
                                          });
                                        }}
                                        name={`telephone_contact`}
                                        placeholder="Telephone Contact"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("contactNotes")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <textarea
                                        className="form-control input-search"
                                        type="text"
                                        value={supplierData.contact_notes}
                                        onChange={(e) => {
                                          setSupplierData({
                                            ...supplierData,
                                            contact_notes: e.target.value,
                                          });
                                        }}
                                        name={`contact_notes`}
                                        placeholder="Contact Notes"
                                        rows={4}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                              </div>
                            )}

                            {activeCustomerTab === "3" && (
                              <div className="row">
                                <div className="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>

                                <p>{t("billingCondition")}</p>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("language")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={languageList}
                                          value={languageList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.language_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              language_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Language"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("Maturity")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={maturityDatesList}
                                          value={maturityDatesList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.maturity_date_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              maturity_date_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Maturity"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("payment_day")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={supplierData.payment_day}
                                          onChange={(e) => {
                                            setSupplierData({
                                              ...supplierData,
                                              payment_day: e.target.value,
                                            });
                                          }}
                                          name={`payment_day`}
                                          maxLength={50}
                                          placeholder="Payment day"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("CommercialDiscount")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={supplierData.discount}
                                          onChange={(e) => {
                                            setSupplierData({
                                              ...supplierData,
                                              discount: e.target.value,
                                            });
                                          }}
                                          name={`discount`}
                                          maxLength={50}
                                          placeholder="Global Discount"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("credit_limit")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={supplierData.credit_limit}
                                          onChange={(e) => {
                                            setSupplierData({
                                              ...supplierData,
                                              credit_limit: e.target.value,
                                            });
                                          }}
                                          name={`credit_limit`}
                                          maxLength={50}
                                          placeholder="Credit limit"
                                        />
                                        {errors.credit_limit && (
                                          <span className="input-error">
                                            {errors.credit_limit}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("paymentMethod")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={paymentMethodList}
                                          value={paymentMethodList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.payment_method_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              payment_method_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Payment Method"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("deliveryMethod")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={deliveryMethodList}
                                          value={deliveryMethodList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.delivery_method_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              delivery_method_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Payment Method"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("copyQuantity")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={
                                            ConfigDB?.data?.copyQuantityList
                                          }
                                          value={ConfigDB?.data?.copyQuantityList.find(
                                            (item) =>
                                              item.value ==
                                              supplierData.copy_quantity_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSupplierData({
                                              ...supplierData,
                                              copy_quantity_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Copy Quantity"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("notes")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={supplierData.notes}
                                          onChange={(e) => {
                                            setSupplierData({
                                              ...supplierData,
                                              notes: e.target.value,
                                            });
                                          }}
                                          name={`notes`}
                                          maxLength={50}
                                          placeholder="Notes"
                                        />
                                      </div>
                                      {errors.notes && (
                                        <span className="input-error">
                                          {errors.notes}
                                        </span>
                                      )}
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("field_notes")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={supplierData.field_notes}
                                          onChange={(e) => {
                                            setSupplierData({
                                              ...supplierData,
                                              field_notes: e.target.value,
                                            });
                                          }}
                                          name={`field_notes`}
                                          maxLength={50}
                                          placeholder="Notes"
                                        />
                                      </div>
                                      {errors.field_notes && (
                                        <span className="input-error">
                                          {errors.field_notes}
                                        </span>
                                      )}
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4" />
                                <div className="col-md-4" />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => navigate("/suppliers")}
                          >
                            <i className="bi bi-arrow-left"> </i> {t("back")}
                          </button>
                        </div>
                        <div className="col">
                          <div className="d-flex justify-content-end nxt-btn">
                            {isModifyButtonLoad ? (
                              <button type="submit" className="btn btn-primary">
                                Loading...
                              </button>
                            ) : (
                              <button type="submit" className="btn btn-primary">
                                {t("submit")} <i className="bi bi-check2"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddSupplier;
